import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import LogRocket from 'logrocket';
import parseDataUrl from 'parse-data-url';
import moment from 'moment';
LogRocket.init('gnpgvk/mobilemind');
export function getToken() {
  var options = {
    credentials: 'include',
    method: 'POST'
  };
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        var response, status;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/rest/session/token', options);

              case 3:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return response.text();

              case 7:
                status = _context.sent;

                if (!status) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", dispatch({
                  type: 'GET_TOKEN',
                  data: status
                }));

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
export function getUserId(extension) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        var response, status, trial, userId, roles, group;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user/me', {
                  credentials: 'include'
                });

              case 3:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 7;
                return response.json();

              case 7:
                status = _context2.sent;

                if (!status) {
                  _context2.next = 14;
                  break;
                }

                userId = status[0].uid[0].value;
                roles = status[0].roles;
                group = status[1];

                if (group) {
                  trial = group.field_trial[0].value;
                } else {
                  trial = false;
                }

                return _context2.abrupt("return", dispatch({
                  type: 'GET_USER_ID',
                  data: userId,
                  trial: trial,
                  roles: roles,
                  group: group
                }));

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 16]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
export function getUser(uid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        var response, status, _status$data, user;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user?filter[uid][value]=' + uid + '&include=roles,user_picture,field_job_title', {
                  credentials: 'include'
                });

              case 3:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 7;
                return response.json();

              case 7:
                status = _context3.sent;

                if (!status) {
                  _context3.next = 13;
                  break;
                }

                _status$data = _slicedToArray(status.data, 1), user = _status$data[0]; // identify the current user for FullStory

                if (typeof FS !== 'undefined') {
                  FS.identify(user.attributes.uid, {
                    displayName: user.attributes.name,
                    email: user.attributes.mail
                  });
                } // identify the current user for LogRocket


                if (typeof LogRocket !== 'undefined') {
                  LogRocket.identify(user.attributes.uid, {
                    name: user.attributes.name,
                    email: user.attributes.mail
                  });
                }

                return _context3.abrupt("return", dispatch({
                  type: 'USER_IS_LOGGED_IN',
                  data: user,
                  included: status.included
                }));

              case 13:
                return _context3.abrupt("return", dispatch({
                  type: 'USER_IS_ANONYMOUS'
                }));

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 16]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
export function updateUserPicture(image) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: 'UPDATE_USER_PICTURE',
                  data: image
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}
export function uploadImage(image, url, filename) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var options, response, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = {
                  credentials: 'include',
                  method: 'POST',
                  headers: new Headers({
                    "Accept": "application/vnd.api+json",
                    "Content-Type": "application/octet-stream",
                    "X-CSRF-Token": getState().session.token,
                    "Content-Disposition": 'file; filename="' + filename + '"'
                  }),
                  body: parseDataUrl(image).toBuffer()
                };
                _context5.prev = 1;
                _context5.next = 4;
                return fetch(process.env.REACT_APP_API_URL + url, options);

              case 4:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;
                return _context5.abrupt("return", data.data);

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](1);
                console.log(_context5.t0);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 12]]);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
export function setNotificationsFetched(user) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var newUser, options;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                newUser = {
                  "data": {
                    "id": user.id,
                    "type": "user--user",
                    "attributes": {
                      "field_notifications_last_fetched": new moment().format()
                    }
                  }
                };
                options = {
                  credentials: 'include',
                  method: 'PATCH',
                  headers: new Headers({
                    'Content-Type': 'application/vnd.api+json',
                    'Accept': 'application/vnd.api+json',
                    'X-CSRF-Token': getState().session.token
                  }),
                  body: JSON.stringify(newUser)
                };
                _context6.prev = 2;
                _context6.next = 5;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user/' + user.id, options);

              case 5:
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](2);
                console.log(_context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 7]]);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}
export function updateProfile(profile, session) {
  var newProfile;
  var jobTitle = null;

  if (profile) {
    if (profile.jobTitle && profile.jobTitle !== 'None') {
      jobTitle = {
        "type": "taxonomy_term--job_titles",
        "id": profile.jobTitle
      };
    }

    newProfile = {
      "data": {
        "id": session.user.id,
        "type": "user--user",
        "attributes": {
          "field_name": profile.name,
          "field_job_title_other": profile.jobTitleOther && profile.jobTitleOther
        },
        "relationships": {
          "field_job_title": {
            "data": jobTitle
          }
        }
      }
    };
  } else {
    newProfile = {
      "data": {
        "id": session.user.id,
        "type": "user--user",
        "relationships": {
          "user_picture": {
            "data": []
          }
        }
      }
    };
  }

  var options = {
    credentials: 'include',
    method: 'PATCH',
    headers: new Headers({
      'Content-Type': 'application/vnd.api+json',
      'Accept': 'application/vnd.api+json',
      'X-CSRF-Token': session.token
    }),
    body: JSON.stringify(newProfile)
  };
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(dispatch) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user/' + session.user.id, options);

              case 3:
                response = _context7.sent;

                if (!response.ok) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 7;
                return response.json();

              case 7:
                data = _context7.sent;
                dispatch({
                  type: 'UPDATE_USER',
                  data: data.data
                });

              case 9:
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](0);
                console.log(_context7.t0);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 11]]);
      }));

      return function (_x9) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}
export function logout() {
  var options = {
    credentials: 'include',
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/vnd.api+json',
      'Accept': 'application/vnd.api+json'
    })
  };
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(dispatch) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user/logout', options);

              case 3:
                response = _context8.sent;

                if (response.ok) {
                  window.location.reload();
                }

                _context8.next = 10;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);
                console.log(_context8.t0);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 7]]);
      }));

      return function (_x10) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}